import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import {
    SPENDBACK_FAILURE,
    SPENDBACK_LOAD,
    SPENDBACK_SUCCESS
} from './spendbackActions';
import { getEntityByName } from '../appEntities';

const initialState = {
    loading: false,
    isChargebackLoading: false,
    isChargebackError: false,
    chargeback: null
};

export default function reducer(state = initialState, action = {}) {
    let newState;
    switch (action.type) {

        case SPENDBACK_LOAD:
            newState = {
                ...state,
                spendback: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case SPENDBACK_SUCCESS:
            newState = {
                ...state,
                loading: false,
                spendback: action.spendback
            };

            return isEqual(state, newState) ? state : newState;

        case SPENDBACK_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getSpendbackEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'spendback')
);

export const getIsSpendbackLoading = createSelector(
    getSpendbackEntity,
    (entity) => get(entity, 'loading')
);

export const getSpendbackError = createSelector(
    getSpendbackEntity,
    (entity) => get(entity, 'error')
);

export const getSpendbackErrorMessage = createSelector(
    getSpendbackError,
    (error) => get(error, 'message')
);

export const getSpendback = createSelector(
    getSpendbackEntity,
    (entity) => get(entity, 'spendback')
);
